var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`unload-list__item-status ${_vm.colorType}`]},[_c('r-text',{attrs:{"type":"caption","color-type":_vm.colorType}},[_vm._v(" "+_vm._s(_vm.statusTitle)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }